﻿import Card from './Card.js';
import Random from './Random.js';


export default class Deck {
    constructor() {
    }
    createDeck(deckName, noShuffle) {
        var cards = [];
        const faces = ['0', 'A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
        const symbols = {
            's': '♠',
            'd': '♦',
            'c': '♣',
            'h': '♥',
        };
        const symbols2 = {
            's': '♤',
            'd': '♢',
            'c': '♧',
            'h': '♡',
        };
        if (typeof deckName === 'undefined') deckName = "";
        for (let i = 1; i < 14; i++) {
            let card = new Card();
            card.id = i + "s" + deckName;
            card.deck = deckName;
            card.number = i;
            card.value = Math.min(i, 10);
            card.suit = "s";
            card.suitValue = 4;
            card.face = faces[card.number];
            card.symbol = symbols[card.suit];
            cards.push(card);
        }
        for (let i = 1; i < 14; i++) {
            let card = new Card();
            card.id = i + "c" + deckName;
            card.deck = deckName;
            card.number = i;
            card.value = Math.min(i, 10);
            card.suit = "c";
            card.suitValue = 2;
            card.face = faces[card.number];
            card.symbol = symbols[card.suit];
            cards.push(card);
        }
        for (let i = 1; i < 14; i++) {
            let card = new Card();
            card.id = i + "d" + deckName;
            card.deck = deckName;
            card.number = i;
            card.value = Math.min(i, 10);
            card.suit = "d";
            card.suitValue = 1;
            card.face = faces[card.number];
            card.symbol = symbols[card.suit];
            cards.push(card);
        }
        for (let i = 1; i < 14; i++) {
            let card = new Card();
            card.id = i + "h" + deckName;;
            card.deck = deckName;
            card.number = i;
            card.value = Math.min(i, 10);
            card.suit = "h";
            card.suitValue = 3;
            card.face = faces[card.number];
            card.symbol = symbols[card.suit];
            cards.push(card);
        }
        if (!noShuffle) {
            this.shuffle(cards);
        }

        for (var i = 0; i < cards.length; i++) {
            let card = cards[i];
            card.pile = "deck";
            card.pilez = i;
        }

        return cards;
    }
    shuffleArray(array) {
        let random = new Random(); //no seed, it will seed itself
        //Fisher-Yates Shuffle
        let currentIndex = array.length;
        let temporaryValue;
        let randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            //randomIndex = Math.floor(Math.random() * currentIndex);
            randomIndex = random.randomInt(0, currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    }
    shuffle(cards) {
        this.shuffleArray(cards);
        for (var i = 0; i < cards.length; i++) {
            let card = cards[i];
            card.pilez = i;
        }
    }
    static createCardsFromArrayString(cardIdsString, pile) {
        let cards = [];
        let cardIds = cardIdsString;
        if (!cardIdsString) return [];
        if (typeof cardIdsString == "string")
            cardIds = cardIdsString.split(",");

        const faces = ['0', 'A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
        const symbols = {
            's': '♠',
            'd': '♦',
            'c': '♣',
            'h': '♥',
        };
        for (var i = 0; i < cardIds.length; i++) {
            let cardId = cardIds[i];
            let number = 0;
            let suit = "";

            if (cardId[0] === 'j' || cardId[0] === 'J') cardId = 11 + cardId[1];
            if (cardId[0] === 'q' || cardId[0] === 'Q') cardId = 12 + cardId[1];
            if (cardId[0] === 'k' || cardId[0] === 'K') cardId = 13 + cardId[1];
            if (cardId[0] === 'a' || cardId[0] === 'A') cardId = 1 + cardId[1];

            if (cardId.length === 2) {
                number = Number(cardId.substring(0, 1));
                suit = cardId.substring(1, 2);
            }
            if (cardId.length === 3) {
                number = Number(cardId.substring(0, 2));
                suit = cardId.substring(2, 3);
            }
            let card = new Card();
            card.id = cardId;
            card.number = number;
            card.value = Math.min(number, 10);
            card.suit = suit;
            //card.suitValue = 1;//todo: set suit value, not sured right now
            card.pile = pile;
            card.pilez = i;
            card.face = faces[card.number];
            card.symbol = symbols[card.suit];

            cards.push(card);
        }
        return cards;
    }
    static createCardIdsFromCards(cards) {
        if (!cards) [];
        let cardIds = cards.map(c => c.id);
        return cardIds;
    }
}